var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuncryptoSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 628,
    viewBox: "0 0 527 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.244 404.793L444.656 404.227",
    stroke: "black",
    strokeWidth: 0.7761,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.614 373.604L477.18 373.186",
    stroke: "black",
    strokeWidth: 0.7761,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.857 121.894L182.605 199.209L419.919 427.839L381.215 464.788L358.537 486.432L325.567 517.912L300.14 542.171L261.2 579.346L38.9844 365.251L77.7359 327.918L262.634 506.038L343.333 428.292L105.783 199.424L265.595 45.4609L482.629 254.553L441.598 294.093L262.857 121.894Z",
    fill: "#EEB91D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500.867 351.203L462.116 313.87L525.26 253.036L262.636 0L0 253.025L63.3795 314.085L0.916499 374.262L263.834 627.558L287.652 604.816L526.987 376.356L500.867 351.203ZM444.655 404.226L419.921 427.839L381.217 464.788L358.54 486.432L325.557 517.913L300.13 542.183L261.191 579.346L38.9865 365.251L77.738 327.918L262.624 506.038L343.323 428.292L158.449 250.161L135.877 271.906L300.248 430.262L267.418 461.89L50.384 252.798L265.597 45.4611L482.631 254.553L441.6 294.082L262.859 121.894L182.607 199.209L381.863 391.174L406.479 367.458L221.593 189.327L253.965 158.14L477.179 373.186L444.655 404.226Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuncryptoSmallIcon);
export default __webpack_public_path__ + "static/media/suncryptoSmallIcon.d0845edffa88871584f99ebe269fe688.svg";
export { ForwardRef as ReactComponent };